export const KANBAN_VIEW_MODES = {
  BOARD: "board",
  LIST: "list",
  CARD: "card",
};

export const KANBAN_ITEM_TYPES = {
  ROW: "row",
};

export const BOARD_COLUMN_MIN_WIDTH = 320;
export const BOARD_COLUMN_MIN_WIDTH_COMPACT = 280;
export const BOARD_COLUMN_RESIZE_MIN_WIDTH = 220;
export const SPLIT_MIN_LEFT = 250;
export const SPLIT_MIN_RIGHT = 450;

export const getStatusName = (statusItem) =>
  statusItem?.skillAssessmentStatus ||
  statusItem?.competencyFrameworkStatus ||
  statusItem?.status ||
  statusItem?.backlogStatus ||
  statusItem?.statusName ||
  statusItem?.name ||
  "";
  
  const colorWithAlpha = (color, alpha = 0.12) => {
  if (!color?.startsWith("#")) return "#f8fafc";

  const hex = color.replace("#", "");
  if (hex.length !== 6) return "#f8fafc";

  const r = Number.parseInt(hex.slice(0, 2), 16);
  const g = Number.parseInt(hex.slice(2, 4), 16);
  const b = Number.parseInt(hex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getRowsByStatus = (rows = []) => {
  const result = {};

  rows.forEach((item) => {
    const status = item?.status || item?.assessmentStatus || "Unassigned";

    if (!result[status]) {
      result[status] = [];
    }

    result[status].push(item);
  });

  return result;
};